import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import StoreOpticians from "./StoreOpticians.js";
const StoreOpticiansContainer = ({ opticians, fallbackImage, ...rest }) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getLabel("stores.page.details.opticians.title")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(StoreOpticians, { ...rest, opticians, fallbackImage, labels });
};
export {
  StoreOpticiansContainer as default
};
//# sourceMappingURL=StoreOpticiansContainer.js.map
